import React from "react";
import { FaTable, FaThLarge } from "react-icons/fa";

// Shared small-screen view control. Desktop tables remain unchanged.
export default function AdminMobileViewToggle({ value, onChange, isDarkMode = false }) {
  const selectedClass = isDarkMode
    ? "bg-slate-700 text-white shadow-sm"
    : "bg-white text-slate-900 shadow-sm";
  const idleClass = isDarkMode ? "text-slate-400" : "text-slate-500";

  return (
    <div className={`inline-flex rounded-xl p-1 md:hidden ${isDarkMode ? "bg-slate-900" : "bg-slate-100"}`} aria-label="Record display">
      <button
        type="button"
        onClick={() => onChange("cards")}
        className={`inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-semibold transition ${value === "cards" ? selectedClass : idleClass}`}
        aria-pressed={value === "cards"}
      >
        <FaThLarge /> Cards
      </button>
      <button
        type="button"
        onClick={() => onChange("table")}
        className={`inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-semibold transition ${value === "table" ? selectedClass : idleClass}`}
        aria-pressed={value === "table"}
      >
        <FaTable /> Table
      </button>
    </div>
  );
}
